import "odometer/themes/odometer-theme-minimal.css";

import Odometer from "odometer";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.odometerOptions = {
    auto: false,
    format: "(.ddd),dd",
};

export default function initGsapOdometer() {
    function gsapOdometer(el) {
        const odometerFormat = el.dataset.odometerFormat;
        const odometerOrigin = el.dataset.odometerOrigin;
        const odometerDestination = el.textContent;

        const odometer = new Odometer({
            el: el,
            value: odometerOrigin,
            format: odometerFormat,
        });

        odometer.update(odometerDestination);
    }

    gsap.utils.toArray(".odometer").forEach((el) => {
        ScrollTrigger.create({
            trigger: el,
            end: "top bottom",
            once: true,
            onEnter: () => {
                gsapOdometer(el);
            },
        });
    });
}
